module.exports = __webpack_public_path__ + "assets/images/profile-icon.9d266a6e4cc0d6735e2578b0f6de72e0.svg";